import {Component, OnInit} from '@angular/core';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {ConfirmDialogService} from '../../../../Services/confirm-dialog.service';
import {DataService} from '../../../../Services/data.service';
import {PmUserBillingRate, PM_WORK_TYPES} from '../../../../DataModels/project.model';

@Component({
  selector: 'app-pm-user-billing-rate-list',
  templateUrl: './pm-user-billing-rate-list.component.html',
  standalone: false,
})
export class PmUserBillingRateListComponent implements OnInit {

  rows: PmUserBillingRate[] = [];
  users: any[] = [];
  workTypes = PM_WORK_TYPES;
  isLoaded = false;
  editingRow: Partial<PmUserBillingRate> | null = null;
  isNew = false;

  constructor(
    private dataService: DataService,
    private notification: BsToastService,
    public confirmDialog: ConfirmDialogService,
  ) {
  }

  ngOnInit(): void {
    this.dataService.getDataWithParams('sys_user', 'pageNumber=0&pageSize=999999').subscribe({
      next: (r: any) => {
        this.users = r?.Data ?? r?.data ?? r ?? [];
      }, error: () => {
      }
    });
    this.load();
  }

  load(): void {
    this.dataService.getData('pm_user_billing_rate').subscribe({
      next: (r: any) => {
        this.rows = r?.Data ?? r?.data ?? r ?? [];
        this.isLoaded = true;
      },
      error: () => {
        this.isLoaded = true;
      }
    });
  }

  get computedEffectiveRate(): number {
    if (!this.editingRow) {
      return 0;
    }
    return (this.editingRow.base_rate ?? 0) * (this.editingRow.rate_modifier ?? 1);
  }

  startNew(): void {
    this.editingRow = {user_id: '', work_type: 'regular', base_rate: 0, rate_modifier: 1, active: true};
    this.isNew = true;
  }

  startEdit(row: PmUserBillingRate): void {
    this.editingRow = {...row};
    this.isNew = false;
  }

  cancelEdit(): void {
    this.editingRow = null;
  }

  save(): void {
    if (!this.editingRow?.user_id || !this.editingRow?.work_type) {
      return;
    }
    const obs = this.isNew
      ? this.dataService.post('pm_user_billing_rate', this.editingRow)
      : this.dataService.patchDataByArray(`pm_user_billing_rate/${(this.editingRow as PmUserBillingRate).id}`, this.editingRow);
    obs.subscribe({
      next: () => {
        this.notification.showSuccessToast('Saved.');
        this.editingRow = null;
        this.load();
      },
      error: () => {
        this.notification.showErrorToast('Error saving.');
      }
    });
  }

  delete(id: string): void {
    this.confirmDialog.confirmThis(['Delete this billing rate?'],
      () => {
        this.dataService.deleteDataById('pm_user_billing_rate', id).subscribe({
          next: () => {
            this.notification.showSuccessToast('Deleted.');
            this.load();
          },
          error: () => {
            this.notification.showErrorToast('Error deleting.');
          }
        });
      }, () => {
      });
  }

  userName(userId: string): string {
    const u = this.users.find(x => x.id === userId);
    return u ? u.name : userId;
  }
}
